import PrimaryLink, { SliderNextButton, SliderPreviousButton } from './StyledLinks';
import projectImgOne from '../assets/makoko/makoko2.jpeg';
import projectImgTwo from '../assets/makoko/makoko1.jpeg';
import React from 'react';
import { Link } from 'react-router-dom';


const ProjectSlider = () => {
    return (
        <>
            <div className='w-2/12 h-1 bg-black mx-3 xl:mx-0'></div>

            <div className='w-full lg:w-9/12 mb-16 px-3 xl:px-0'>
                <h2 className='text-6xl font-bold uppercase tf-rozha tracking-wide'>PROJECTS</h2>
                <p className='text-2xl tf-inter tracking-widest leading-loose font-extralight'>Explore our recent projects showcasing little and impactful solutions to the community.</p>
            </div>
            
            <div className='flex flex-col xl:flex-row w-full'>
                <div className='flex flex-col justify-between'>
                    <div className='flex-1 flex place-items-center justify-end'>
                        <h4 className='text-right font-extrabold text-8xl tracking-widest text-[#0e1b1b46]'>2024</h4>
                    </div>
                    <div className='xl:relative xl:left-5'>
                        <div className='hidden xl:flex w-full h-[195px] grow bg-no-repeat bg-center bg-cover flex-col gap-y-4' style={{ backgroundImage: `url(${projectImgTwo})` }}></div>
                    </div>
                </div>

                <div className='flex flex-col gap-y-8 xl:gap-y-0 xl:flex-row gap-x-14 justify-end'>
                    <div className='flex flex-col gap-y-4 justify-between'>
                        <div className='w-full xl:w-[420px] h-[325px] grow bg-no-repeat bg-center' style={{ backgroundImage: `url(${projectImgOne})` }}></div>
                        <div className='relative -top-20 xl:block xl:top-0 w-6/12 sm:w-4/12 mt-2 self-center'>
                            <PrimaryLink to={'https://youtube.com/shorts/X4V37PhMFys?si=HlWz5G4-eCE-0rKL'} className='absolute'>
                                <div className='flex place-items-center gap-x-1'>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M12.25 3.5C7.425 3.5 3.5 7.425 3.5 12.25C3.5 17.075 7.425 21 12.25 21C17.075 21 21 17.075 21 12.25C21 7.425 17.075 3.5 12.25 3.5ZM12.25 22.5C6.598 22.5 2 17.902 2 12.25C2 6.598 6.598 2 12.25 2C17.902 2 22.5 6.598 22.5 12.25C22.5 17.902 17.902 22.5 12.25 22.5Z" fill="black" />
                                        <path fillRule="evenodd" clipRule="evenodd" d="M11.134 10.0865C10.957 11.0875 10.954 13.4785 11.131 14.4285C12.009 14.1185 13.911 12.8685 14.423 12.2495C13.913 11.6485 12.035 10.4245 11.134 10.0865ZM10.828 16.0015C10.558 16.0015 10.302 15.9245 10.093 15.7165C9.932 15.5575 9.502 15.1325 9.5 12.3335C9.499 9.36151 9.946 8.91951 10.093 8.77251C10.616 8.25451 11.468 8.60951 11.831 8.76151C12.351 8.97851 16 10.8475 16 12.2455C16 13.5555 12.716 15.3875 11.877 15.7375C11.55 15.8735 11.177 16.0015 10.828 16.0015Z" fill="black" />
                                    </svg>
                                    <span className='font-bold text-sm underline tf-rozha'>Watch Video</span>
                                </div>
                            </PrimaryLink>
                        </div>
                    </div>

                    <div className='h-full self-center flex flex-col justify-between gap-y-6 px-3 xl:px-0'>
                        <div className='grow flex flex-col justify-center'>
                            <Link to={'/projects/makoko-2024'} className='text-4xl tf-inter font-light mb-6'>Makoko for Christ</Link>
                            <p className='font-light tracking-wider leading-loose'>Highlights of visit to Makoko, where students were uplifted with thoughtful gift distributions and the preaching of the gospel. The initiative reflects a commitment to community transformation and spreading hope.</p>
                        </div>

                        <div className='flex flex-col gap-y-5 place-items-end xl:w-5/12 xl:mx-auto'>
                            <SliderNextButton />
                            <SliderPreviousButton />
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default ProjectSlider